import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import axios from "axios";
import { searchText } from "../../actions/SearchActions";
import { Container, Row, Col } from "reactstrap";
import Banner from "../Banner/Banner";
import CategoryGames from "../CategoryGames/CategoryGames";
import { messages } from "../../constants/messages";
import * as vars from "../../constants/variables";
import { showMessage } from "../../actions/FlashMessageActions";
import {
  getGames,
  getFavouriteGames,
  setFavouriteGames,
} from "../../actions/GamesActions";
import { show, hide } from "../../actions/ActivityIndicatorActions";
import CategoryList from "../CategoryList/CategoryList";
import { appendUid } from "../../utils/helper";
import { FormattedMessage } from "react-intl";
import { config } from "../../constants/domainConfig";
import { sendData } from "../../analytics/sendData";
import { isGamiclub } from "../../constants/isGamiclub";
import CategoryGamesDemo from "../CategoryGames/CategoryGamesDemo";

let msg = messages;

class DemoPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      gameType: "",
      switcherState: false,
      loading: true,
    };
    this.openGame = this.openGame.bind(this);
  }

  componentWillMount() {
    if (this.props.games.games.length <= 0) {
    }
    if (this.props.history.location.pathname.split('/')[2] == 'html') {
      this.setState({
          gameType: 'html5'
      });
      
    } else if (this.props.history.location.pathname.split('/')[2] == 'android') {
      this.setState({
          gameType: 'android'
      });
      
    } else if (this.props.history.location.pathname.split('/')[2] == 'video' && (isGamiclub || config.subDomain === 'za' || config.subDomain === 'kw' || config.subDomain === 'pt')) {
      this.setState({
          gameType: 'video'
      });
      
    }
    else {
      this.props.history.push("/maxis-welcome")
    }
    this.props.searchText("");
    if (this.props.categories.categories)
      this.setState({ categoriesTranslated: true });
  }

  componentDidMount() {
    if (this.props.categories.categories)
      this.setState({ categoriesTranslated: true });
    window.scrollTo(0, 0);
  }


  openGame(game, e) {
    e.preventDefault();
    if (e.target.tagName != "INPUT") {
      this.props.history.push(
        appendUid("/play-maxis/" + game.gameId, this.props.access.uid)
      );
    }
  }

  render() {
    let bannerData;
    let htmlBannerDataMobile;
    let htmlBannerData;
    console.log("gametype - ", this.state.gameType);
    if (this.state.gameType == "html5") {
      htmlBannerData = [
        {
          //imgUrl: './img/html5-banner.jpg',
          imgUrl: "./img/my-html5-banner-new.png",
          offer: null,
          game_name: "",
          category_name: "",
          //id: 34
          id: 26,
        },
      ];
      htmlBannerDataMobile = [
        {
          //imgUrl: './img/mobile-html5-banner.jpg',
          imgUrl: "./img/my-html5-banner-new.png",
          offer: null,
          game_name: "",
          category_name: "",
          //id: 34
          id: 26,
        },
      ];

      if (config.subDomain == "my") {
        htmlBannerData[0].imgUrl = "./img/my-html5-banner-new.png";
        htmlBannerDataMobile[0].imgUrl = "./img/my-html5-banner-new.png";
        htmlBannerData[0].id = 26;
        htmlBannerDataMobile[0].id = 26;
      }

      if (window.innerWidth <= 575) {
        bannerData = htmlBannerDataMobile;
      } else {
        bannerData = htmlBannerData;
      }
    }
    else if (this.state.gameType == 'video') {
      bannerData = [
              {
                  imgUrl: './img/gamiclub-banner.png',
                  offer: null,
                  game_name: '',
                  category_name: '',
                  id: undefined
              }
          ];
    } 
    else {
      let androidBannerData, androidBannerDataMobile;
      androidBannerData = [
        {
          imgUrl: "./img/android-banner.jpg",
          offer: null,
          game_name: "",
          category_name: "",
          id: 122,
        },
      ];
      androidBannerDataMobile = [
        {
          imgUrl: "./img/mobile-android-banner.jpg",
          offer: null,
          game_name: "",
          category_name: "",
          id: 122,
        },
      ];

      if (window.innerWidth <= 575) {
        bannerData = androidBannerDataMobile;
      } else {
        bannerData = androidBannerData;
      }
    }

    return (
      <div className="home-page">
        <Banner bannerData={bannerData} />
        <Container fluid>
          <div>
            {this.props.categories.categories.length > 0
              ? this.props.categories.categories.map((category, index) => {
                  if (
                    category.categoryTypeName.toLowerCase() ==
                    this.state.gameType
                  ) {
                    return (
                      <CategoryGamesDemo
                        key={index}
                        index={index}
                        category={category}
                        games={
                          this.props.games.games.length > 0 &&
                          this.props.games.games.filter((g) => {
                            return g.categoryId == category.categoryId;
                          }).length > 0
                            ? this.props.games.games.filter((g) => {
                                return g.categoryId == category.categoryId;
                              })
                            : []
                        }
                        onFavoriteClick={this.openGame}
                      />
                    );
                  }
                })
              : ""}
          </div>
        </Container>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    access: state.WelcomeReducer,
    domains: state.DomainReducer,
    country: state.CountryReducer,
    categories: state.CategoryReducer,
    games: state.GamesReducer,
    flashmessage: state.FlashMessageReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getGames,
      getFavouriteGames,
      setFavouriteGames,
      show,
      hide,
      showMessage,
      searchText,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(DemoPage);



// WEBPACK FOOTER //
// ./src/components/DemoPage/DemoPage.js